import firebase from 'firebase/app';
import { useEffect, useState } from 'react';

const useLocPeopleIndex = (cid, location) => {
   const [data, setData] = useState([]);
   useEffect(() => {
      let isMounted = true;
      const fetchData = async () => {
         if (!cid || !location) {
            setData([]);
            return;
         }
         const coPeople = await firebase
            .firestore()
            .doc(`company/${cid}/indexes/people`)
            .get();
         let people = [];
         if (coPeople.exists) {
            Object.entries(coPeople.data()).forEach(([key, value]) => {
               if (value.lid === location.lid) {
                  people.push({
                     id: key,
                     email: value.email,
                     name: `${value.name.firstName} ${value.name.lastName}`,
                     type: 'user',
                  });
               }
            });
         }
         people.sort((a, b) => {
            const nameCompare = a.name.localeCompare(b.name);
            if (nameCompare !== 0) return nameCompare;
            return a.id.localeCompare(b.id);
         });
         if (location.groups) {
            const groupsResponse = await firebase
               .firestore()
               .doc(`location/${location.lid}/indexes/groups`)
               .get();
            let groups = [];
            if (groupsResponse.exists) {
               console.log(groupsResponse.data());
               Object.entries(groupsResponse.data()).forEach(([key, value]) => {
                  groups.push({
                     id: key,
                     email: null,
                     name: value.name,
                     type: 'group',
                  });
               });
            }
            groups.sort((a, b) => {
               const nameCompare = a.name.localeCompare(b.name);
               if (nameCompare !== 0) return nameCompare;
               return a.id.localeCompare(b.id);
            });
            people.unshift(...groups);
         }

         people.unshift({
            id: location.lid,
            email: null,
            name: `${location.name}`,
            type: 'location',
         });
         if (isMounted) setData(people);
      };
      fetchData();
      return () => {
         isMounted = false;
      };
   }, [cid, location, firebase]);
   return data;
};
export default useLocPeopleIndex;
